/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import { RemoveRedEye } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "FDCAPPROVEDFARMERDETAILSREPORT"

export default function FarmerOnboardingView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'FDC 2nd Approved Farmer Details Report'
    });

    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [farmerDetails, setFarmerDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [datevalue, setDateValue] = useState(new Date());
    const [cropData, setCropData] = useState({
        farmerName: ''
    });

    const status = [
        {
            value: 1,
            label: 'New'
        },
        {
            value: 2,
            label: 'FCC Approved'
        },
        {
            value: 3,
            label: 'FDC First Approved'
        },
        {
            value: 4,
            label: 'FDC Second Approved'
        },
        {
            value: 5,
            label: 'FCC Rejected'
        },
        {
            value: 6,
            label: 'FDC First Rejected'
        },
        {
            value: 7,
            label: 'FDC Second Rejected'
        },
    ]
    const [formData, setFormData] = useState({
        groupID: '',
        factoryID: '',
        statusID: '4',
        date: null
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        factoryID: '',
        date: '',
        statusID: ''
    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [bankDetails, setbankDetails] = useState([]);
    const [accountDetails, setaccountDetails] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const FDC2ndApprovedFarmerDetailsReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        factoryID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            factoryID: selectedOptions,
            statusID: formData.statusID,
            date: formData.date
        },

        validationSchema: FDC2ndApprovedFarmerDetailsReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });
    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        GetFarmerAccountDetails();
    }, [bankDetails, selectedSearchValues]);

    useEffect(() => {
        setValues({
            ...values,
            statusID: 4
        })
    }, [formik.values.groupID]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [formik.values.groupID, formik.values.factoryID, formik.values.statusID]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [datevalue]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [selectedOptions, selectedOptionsStatus]);

    useEffect(() => {
        setSelectedOptions([]);
        setSelectedOptionsStatus([]);
    }, [formik.values.groupID]);

    useEffect(() => {
        setSelectedOptionsStatus([]);
    }, [formik.values.factoryID]);

    useEffect(() => {
        setValues({
            ...values,
            factoryID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [datevalue]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - farmerDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFDCAPPROVEDFARMERDETAILSREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
            statusID: '4'
        })
        trackPromise(GetAllGroups());
    }

    //tobackend
    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            factoryID: selectedOptions.map(x => x).join(',').toString(),
            statusID: parseInt(values.statusID),
            date: datevalue == null ? null : new Date(datevalue),
        }
        var res = await services.GetFDC2ndApprovedFarmerDetails(model)
        setFarmerDetails(res);
        getSelectedDropdownValuesForReport();
    }

    async function SubmitFarmerDetails(farmerID) {
        var res = await services.GetFarmerBankDetailsByFarmerID(farmerID)
        if (res != null) {
            setbankDetails(res)
        }
        setOpen(true)
    }

    async function GetFarmerAccountDetails() {
        var res = await services.GetFarmerAccountNumbersByFarmerID()
        setaccountDetails(res)
    }

    const handleClose = () => {
        setOpen(false);
    };

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setFarmerDetails([]);
            setDateValue(null);
            setDateValue(new Date());
            setValues({
                ...values,
                factoryID: ''
            })
            setSelectedOptionsStatus([]);
            setSelectedOptions([]);
        } else {
            setSelectedOptionsStatus([]);
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(farmerDetails);
        var settings = {
            sheetName: 'FDC 2nd Approved Farmer Details',
            fileName: 'FDC 2nd Approved Farmer Details',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'FDC 2nd Approved Farmer Details',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var accounts = accountDetails.filter(y => y.farmerID == x.farmerID)
                var vr = {
                    'Fresh Collection Center': x.fcc == null | x.fcc == false ? '-' : x.fcc,
                    'Supplier Code- Agrithmics': x.farmerCode == null | x.farmerCode == false ? '-' : x.farmerCode,
                    'Supplier Code- Navision': x.navisionNumber == null | x.navisionNumber == false ? '-' : x.navisionNumber,
                    'Supplier Full Name': x.givenName == null | x.givenName == false ? '-' : x.givenName,
                    'NIC/BRN Number': x.nic == null | x.nic == false ? '-' : x.nic,
                    'Address 1': x.address1 == null | x.address1 == false ? '-' : x.address1,
                    'Address 2': x.address2 == null | x.address2 == false ? '-' : x.address2,
                    'Mobile Number': x.mobileNumber == '' ? '' : x.mobileNumber,
                    'Account Number': (() => {
                        if (accounts.length === 1 || (accounts.length > 1 && accounts.some(acc => acc.isDefault))) {
                            const defaultAccount = accounts.find(acc => acc.isDefault);
                            return defaultAccount ? defaultAccount.accountNumber : accounts[0].accountNumber;
                        } else {
                            return '-';
                        }
                    })()
                }
                res.push(vr);
            });

            res.push({});
            res.push({});

            var vr = {
                'Fresh Collection Center': "Group : " + selectedSearchValues.groupID,
                'Supplier Code- Navision': "Fresh Collection Center : " + selectedSearchValues.factoryID,
                'NIC/PVR Number': "Status : " + (selectedSearchValues.statusID == 1 ? 'New' : selectedSearchValues.statusID == 2 ? 'FCC Approved' : selectedSearchValues.statusID == 3 ? 'FDC First Approved' : selectedSearchValues.statusID == 4 ? 'FDC Second Approved' :
                    selectedSearchValues.statusID == 5 ? 'FCC Rejected' : selectedSearchValues.statusID == 6 ? 'FDC First Rejected' : selectedSearchValues.statusID == 7 ? 'FDC Second Rejected' : 'All Status'),
            }
            res.push(vr);
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            factoryID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            statusID: formik.values.statusID,
            date: new Date(datevalue).toLocaleDateString()
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="FDC 2nd Approved Farmer Details Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.factoryID && errors.factoryID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center"
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.factoryID && errors.factoryID && (
                                            <FormHelperText>{errors.factoryID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Status *"
                                        value={formik.values.statusID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('statusID')}
                                        error={Boolean(touched.statusID && errors.statusID)}
                                        helperText={touched.statusID && errors.statusID}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                        style={{ flex: '1 0 33%' }}
                                    >
                                        <MenuItem key={0} value={0}>Select Status</MenuItem>
                                        {status.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <div style={{ flex: '1 0 33%' }}></div>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="flex-end" spacing={2} style={{ flex: '1 0 30%' }}>
                                        <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                                            Clear
                                        </Button>
                                        <Button type="submit" color="secondary" variant="outlined">
                                            Search
                                        </Button>
                                    </Stack>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={cropData.farmerName}
                                            placeholder="Search"
                                            onChange={(e) => { handleChange(e) }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {farmerDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                            <TableContainer component={Paper} >
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">Fresh Collection Center</TableCell>
                                                            <TableCell align="center">Supplier Code-Agrithmics</TableCell>
                                                            <TableCell align="center">Supplier Code-Navision</TableCell>
                                                            <TableCell align="center">Supplier Full Name</TableCell>
                                                            <TableCell align="center">NIC/BRN</TableCell>
                                                            <TableCell align="center">Address line 1</TableCell>
                                                            <TableCell align="center">Address line 2</TableCell>
                                                            <TableCell align="center">Contact Number</TableCell>
                                                            <TableCell align="center">Bank Account Number</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? farmerDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : farmerDetails
                                                        ).map((row) => (
                                                            <TableRow key={row.fcc}>
                                                                <TableCell align="center">
                                                                    {row.fcc}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.farmerCode == null | row.farmerCode == false ? '-' : row.farmerCode}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.navisionNumber == null | row.navisionNumber == false ? '-' : row.navisionNumber}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.givenName == null | row.givenName == false ? '-' : row.givenName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.nic == null | row.nic == false ? '-' : row.nic}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.address1 == null | row.address1 == false ? '-' : row.address1}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.address2 == null | row.address2 == false ? '-' : row.address2}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.mobileNumber == null | row.mobileNumber == false ? '-' : row.mobileNumber}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <RemoveRedEye onClick={() => SubmitFarmerDetails(row.farmerID)}>
                                                                    </RemoveRedEye>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={10}
                                                                count={farmerDetails.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="FDC 2nd Approved Farmer Details" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{"Account Details"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Container>
                                    {bankDetails.length > 0 && (
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        </Stack>
                                    )}
                                    <Card style={{ justifycontent: 'center', width: '31rem' }}>
                                        <Paper className={classes.root}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="collapsible table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Account Numbers</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Bank Name</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Branch Name</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Default</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {bankDetails.map((row, i) => {
                                                            if ((bankDetails.length === 1) || (bankDetails.length > 1 && row.isDefault === true)) {
                                                                return (
                                                                    <TableRow key={i}>
                                                                        <TableCell component="th" scope="row" align="left"> {row.accountNumber == null | row.accountNumber == false ? '-' : row.accountNumber}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.bankName == null | row.bankName == false ? '-' : row.bankName}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.branchName == null | row.branchName == false ? '-' : row.branchName}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right">
                                                                            {row.isDefault == null | row.isDefault == false ? 'No' : 'Yes'}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                            return null;
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Card>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="secondary">
                                            CANCEL
                                        </Button>
                                    </DialogActions>
                                </Container>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                    {farmerDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"FDC 2nd Approved Farmer Details"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    farmerDetails={farmerDetails}
                                    searchData={selectedSearchValues}
                                    accountDetails={accountDetails}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}